module.exports = __webpack_public_path__ + "static/light-logo-7b27e3ebb0f92d7d24206fde9f85603b.svg";